import api from 'plugin/api';

/**
 *  @description 검사성분관리 목록 API
 */

async function inspIrdntList(params) {
  const url = '/sfsh/inspection/irdnt';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 검사성분관리 등록 API
 */

async function inspIrdntCreate(requestBody) {
  const url = '/sfsh/inspection/irdnt';

  const response = await api.post(url, requestBody);
  return response;
}

/**
 *  @description 검사성분관리 상세 API
 */
async function inspIrdntDetail(seq) {
  const url = `/sfsh/inspection/irdnt/${seq}`;

  const response = await api.get(url);
  return response;
}

/**
 *  @description 검사성분관리 수정 API
 */
async function inspIrdntUpdate(seq, requestBody) {
  const url = `/sfsh/inspection/irdnt/${seq}`;

  const response = await api.put(url, requestBody);
  return response;
}

/**
 *  @description 검사결과서코드 중복검사 API
 */
async function inspLabCodeCheck(requestBody) {
  const url = '/sfsh/inspection/irdnt/chk-dup/lab-insp-irdnt-cd';

  const response = await api.post(url, requestBody);
  return response;
}

export {
  inspIrdntList,
  inspIrdntCreate,
  inspIrdntDetail,
  inspIrdntUpdate,
  inspLabCodeCheck
};
